import { GetSupportTicketsResponse } from "@src/types/support";

export const mockSupportTickets: GetSupportTicketsResponse = {
  result_index: 0,
  result_count: 10,
  tickets: [
    {
      type: "SUPPORT_AGENT_TICKET",
      org_name: "Mock Org",
      auto_translate: false,
      handled_by_ai_chatbot: false,
      id: "1",
      assigned_to: {
        type: "CUSTOMER",
        id: "258843904869194112",
        name: "Alice Brown",
        email: "alice.brown@example.com",
        organization: { id: 1, name: "Acme Industries" },
      },
      machine: {
        machine_id: "550e8400-e29b-41d4-a716-446655440000",
        machine_name: "Temperature Sensor A1",
        gateway_id: null,
        source_dsn: "mqtt://broker.example.com/device-001",
      },
      created_at: "2024-05-01T10:00:00Z",
      raised_by: {
        id: "201",
        name: "John Doe",
        email: "john.doe@example.com",
      },
      last_updated_at: "2024-05-01T11:00:00Z",
      priority: "high",
      status: "open",
      title:
        "Temperature sensor stopped reporting veeeeeeery long title to test text overflow handling in the UI",
      description:
        "Sensor stopped sending MQTT telemetry after firmware update.",
      comments: [],
      issue_type: "problem",
      collaborators: [],
      via: { channel: "web" },
    },

    {
      type: "SUPPORT_AGENT_TICKET",
      org_name: "Mock Org",
      auto_translate: false,
      handled_by_ai_chatbot: false,
      id: "2",
      assigned_to: null,
      machine: {
        machine_id: "22222222-2222-2222-2222-222222222222",
        machine_name: "Pressure Node P12",
        gateway_id: null,
        source_dsn: "opc.tcp://192.168.0.10:4840",
      },
      created_at: "2024-05-02T08:30:00Z",
      raised_by: {
        id: "202",
        name: "Emma Wilson",
        email: "emma.wilson@example.com",
      },
      last_updated_at: "2024-05-02T09:00:00Z",
      priority: "normal",
      status: "solved",
      title: "OPC-UA node intermittent disconnect",
      description:
        "The pressure node disconnects every few minutes from the OPC-UA server.",
      comments: [],
      issue_type: "incident",
      collaborators: [],
      via: { channel: "email" },
    },

    {
      type: "SUPPORT_AGENT_TICKET",
      org_name: "Mock Org",
      auto_translate: false,
      handled_by_ai_chatbot: false,
      id: "3",
      assigned_to: {
        type: "CUSTOMER",
        id: "103",
        name: "Sarah Miller",
        email: "sarah.miller@example.com",
        organization: { id: 3, name: "Green Energy Ltd" },
      },
      machine: {
        machine_id: "c1b2c3d4-e29b-41d4-a716-446655440111",
        machine_name: "OPC-UA Pressure Node",
        gateway_id: null,
        source_dsn: "opc.tcp://192.168.1.25:4840",
      },
      created_at: "2024-05-03T07:00:00Z",
      raised_by: {
        id: "203",
        name: "Lucas Green",
        email: "lucas.green@example.com",
      },
      last_updated_at: "2024-05-03T08:10:00Z",
      priority: "urgent",
      status: "open",
      title: "Wind turbine data missing",
      description:
        "Wind turbine telemetry has not been received for the last hour.",
      comments: [],
      issue_type: "incident",
      collaborators: [],
      via: { channel: "api" },
    },

    {
      type: "SUPPORT_AGENT_TICKET",
      org_name: "Mock Org",
      auto_translate: false,
      handled_by_ai_chatbot: false,
      id: "4",
      assigned_to: {
        type: "CUSTOMER",
        id: "104",
        name: "David Lee",
        email: "david.lee@example.com",
        organization: { id: 4, name: "Industrial Systems" },
      },
      machine: {
        machine_id: "a7b8c9d0-e29b-41d4-a716-446655440222",
        machine_name: "Humidity Sensor B4",
        gateway_id: null,
        source_dsn: "mqtt://broker.example.com/device-042",
      },
      created_at: "2024-05-04T12:20:00Z",
      raised_by: {
        id: "204",
        name: "Anna Fischer",
        email: "anna.fischer@example.com",
      },
      last_updated_at: "2024-05-04T13:00:00Z",
      priority: "low",
      status: "new",
      title: "Humidity readings incorrect",
      description: "Sensor values appear offset compared to manual readings.",
      comments: [],
      issue_type: "question",
      collaborators: [],
      via: { channel: "web" },
    },

    // 6 more simple ones to reach 10
    ...Array.from({ length: 6 }).map((_, i) => ({
      type: "SUPPORT_AGENT_TICKET" as const,
      org_name: "Mock Org",
      id: String(5 + i),
      assigned_to: {
        type: "CUSTOMER" as const,
        id: `${200 + i}`,
        name: `Agent ${i}`,
        email: `agent${i}@example.com`,
        organization: { id: 10, name: "Demo Corp" },
      },
      machine: {
        machine_id: "00000000-0000-0000-0000-00000000000${i}",
        machine_name: "Demo Sensor ${i}",
        gateway_id: null,
        source_dsn: "mqtt://demo/device-${i}",
      },
      created_at: "2024-05-05T10:00:00Z",
      raised_by: {
        id: `${300 + i}`,
        name: `User ${i}`,
        email: `user${i}@example.com`,
      },
      last_updated_at: "2024-05-05T11:00:00Z",
      priority: "normal" as const,
      status: "open" as const,
      title: `Demo ticket ${i}`,
      description: `Mock support ticket ${i}`,
      comments: [],
      issue_type: "task",
      auto_translate: false,
      handled_by_ai_chatbot: false,
      collaborators: [],
      via: { channel: "web" },
    })),
  ],
};
